// extracted by mini-css-extract-plugin
export default {"container":"AdminPanel_container__xtux2","admin":"AdminPanel_admin__XmyXY","title":"AdminPanel_title__JN9g2","hr":"AdminPanel_hr__R+CQe","voters":"AdminPanel_voters__QXA9b"};